import { CalendarClock } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { formatDate } from '@/lib/format';
import { useMaintenanceSchedules } from '@/features/assembly/assemblyApi';
import { TaskCard, TaskRow } from './TaskCard';

/** Fällig in ≤ 30 Tagen oder bereits überfällig. */
function isDueSoon(nextDueAt: string): boolean {
  return new Date(nextDueAt).getTime() <= Date.now() + 30 * 24 * 60 * 60 * 1000;
}

/** Fällige Wartungen (Montage-Modul). Operatives Widget — Berechtigung assembly.read. */
export function DueMaintenanceWidget() {
  const maintenance = useMaintenanceSchedules();
  const dueMaintenance = (maintenance.data?.data ?? [])
    .filter((schedule) => schedule.isActive && isDueSoon(schedule.nextDueAt))
    .sort((a, b) => a.nextDueAt.localeCompare(b.nextDueAt));

  return (
    <TaskCard
      title="Fällige Wartungen"
      icon={CalendarClock}
      isLoading={maintenance.isLoading}
      isEmpty={dueMaintenance.length === 0}
      emptyText="Keine Wartung in den nächsten 30 Tagen."
    >
      {dueMaintenance.slice(0, 6).map((schedule) => {
        const isOverdueItem = new Date(schedule.nextDueAt).getTime() < Date.now();
        return (
          <TaskRow
            key={schedule.id}
            to="/montage"
            left={
              <>
                <span className="text-foreground">{schedule.title}</span>
                {schedule.customerName && (
                  <span className="ml-2 text-xs text-muted-foreground">{schedule.customerName}</span>
                )}
              </>
            }
            right={
              <Badge tone={isOverdueItem ? 'danger' : 'warning'}>
                {isOverdueItem ? 'überfällig' : 'fällig'} {formatDate(schedule.nextDueAt)}
              </Badge>
            }
          />
        );
      })}
    </TaskCard>
  );
}
